module.exports = __webpack_public_path__ + "img/wild_comming.44e673be.png";